import { render, staticRenderFns } from "./ProcessLeaverHistory.vue?vue&type=template&id=eb77aa92&"
import script from "./ProcessLeaverHistory.vue?vue&type=script&lang=ts&"
export * from "./ProcessLeaverHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports